import { Injectable, inject } from '@angular/core'
import { Filter, RestClientPaged } from '@elderbyte/ngx-starter'
import { Printer } from './printer'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'

export class PrinterFilter {
  /*
  public static printSystem(printSystem: string): Filter {
    return new Filter('printSystem', printSystem);
  }*/

  public static facility(facility: string): Filter {
    return new Filter('facility', facility)
  }
}

@Injectable({
  providedIn: 'root',
})
export class PrinterService extends RestClientPaged<Printer, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/printers', http, {
      idField: 'id',
    })
  }
}
